import React from 'react';

export const changeDescription = (
  <div>
    <h3 className="vads-u-font-size--h5">Changes in physical health</h3>
    <p>
      Please let us know about any changes in your physical health as a result
      of the event. You may have experienced some or none of these. (Check any
      that apply.)
    </p>
  </div>
);
